import React, { useState } from "react";

import PageName from "../../shared/components/PageName";
import DataTable from "../../shared/components/table/DataTable";
import AddModal from "../../components/components/AddModal";

import { teachersData } from "../../../home/topTeachers/utils/teachersData";
import { formatToExcelTableShapeForTeacher } from "../../shared/utils/excelShapeFormat";
import { convertToExcel } from "../../shared/utils/convertToExcel";

import classes from "./TeachersPage.module.css";

const TeachersPage = () => {
  const [openModal, setOpenModal] = useState(false);
  const columns = [
    {
      title: "#",
      dataIndex: "id",
      width: "5%",
      editable: false,
    },
    {
      title: "Name",
      dataIndex: "name",
      width: "25%",
      editable: true,
    },
    {
      title: "Lastname",
      dataIndex: "lastName",
      width: "20%",
      editable: true,
    },
    {
      title: "Workplace",
      dataIndex: "workplace",
      width: "40%",
      editable: true,
    },
  ];

  return (
    <div>
      <PageName
        pageName="Teachers"
        totalRecords={teachersData}
        excelExport={() =>
          convertToExcel(formatToExcelTableShapeForTeacher(teachersData))
        }
      />
      <button className={classes["plus"]} onClick={() => setOpenModal(true)}>
        +
      </button>
      <DataTable tableData={teachersData} columns={columns} />
      <AddModal openModal={openModal} onClose={() => setOpenModal(false)} />
    </div>
  );
};

export default TeachersPage;
